import useSWRMutation from 'swr/mutation'
import {getAccessToken} from '../helper/authHelper'
import {useIsAuthenticated, useMsal} from '@azure/msal-react'
import {loginRequest} from '../auth/auth-config'

// Custom hook that returns the SendRequest function
function useSendRequest() {
  const {instance, accounts, inProgress} = useMsal()
  const isAuthenticated = useIsAuthenticated()

  // Return a function that can be used to send requests
  return async function SendRequest(url, {arg}) {
    const accessToken = await getAccessToken(instance, accounts, inProgress)
    if (isAuthenticated) {
      return fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`
        },
        body: JSON.stringify(arg)
      }).then((res) => res.json())
    } else {
      instance.loginRedirect(loginRequest)
    }
  }
}

export function useLlmApi(urlTerm) {
  const SendRequest = useSendRequest() // Use the custom hook to get the SendRequest function
  const {trigger, isMutating, data, error} = useSWRMutation(
    process.env.NODE_ENV === 'production'
      ? globalThis.__env.REACT_APP_API_LLM_URL
      : process.env.REACT_APP_API_LLM_URL + urlTerm,
    SendRequest
  )
  return {trigger, isMutating, data, error}
}
